import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, of, Subscription ,from} from "rxjs";
import {MaterialInstance, MaterialService} from "../shared/classes/material.service";
 import {StreamsService}  from "../shared/services/streams.service";
 import {StatService}  from "../shared/services/stat.service";
import {WatchTokenService}  from "../shared/services/watch-token.service";
 
import {StreamProject} from "../shared/interfaces";
import { switchMap, catchError, map, delay} from 'rxjs/operators';
import { ActivatedRoute, Router} from '@angular/router';
 
@Component({
  selector: 'app-watchers-page',
  templateUrl: './watchers-page.component.html',
  styleUrls: ['./watchers-page.component.scss'], 
 
})
export class WatchersPageComponent {
 
  
  constructor(
    public streamsService: StreamsService,
    public tokenService: WatchTokenService,
    public route:  ActivatedRoute,
 private statService: StatService,
      private router: Router
    ){
 
 
  } 

 watchersExceededLimit = false

  stream: StreamProject = null
 // streamSubscribtion: any = false
  initialLoading: boolean = true
  accessOk: boolean = null
  isEmbed: boolean = false
  isEmbedChannel: boolean = false
  description: string = ""
 sessionKey;
  //stream$:Observable<StreamProject>

  ngOnInit() { 
   

     from(this.route.queryParams.pipe(
     // delay(5000),
      switchMap((params: any)=>{


        

        if(params['embed'] === "true"){
          this.isEmbed = true
        }


         if(params['embed-channel'] === "true"){
          this.isEmbedChannel = true
        }

         return this.streamsService.getPubliishByPublicKey(params['v']).pipe(


		 catchError((error) => {
 			console.log(error)
                     if(error.status === 404){ this.router.navigate(['/channel']);  return of({}) }

                     if(error.status === 412){ this.onWatchersExceededLimit();  return of({}) }

		} ),


          switchMap((stream: any)=>{

            if(stream.accessLevel === 0){
 
              this.tokenService.deleteToken(stream.publicIdentity)
              this.accessOk = true
              return of(stream)
            }else{

                const potentialToken = this.tokenService.getToken(stream.publicIdentity)
  
                if(!potentialToken){
                  this.accessOk = false
                  return of(stream)
                } else {
 
                  return this.streamsService.checkWatchAccessToken(stream._id,potentialToken).pipe(
                    switchMap((data: any)=>{
                     
                      if(data.error){
                        this.tokenService.deleteToken(stream.publicIdentity)
                        this.accessOk = false
                        return of(stream)
                      }

                      
                
                      if(data.token){
                        this.tokenService.setToken(stream.publicIdentity, data.token)
                        this.accessOk = true
                        return of(stream)
                      }  else {
                        this.accessOk = false
                        return of(stream)
                      }
                      
                    }),
                    catchError((error)=>{

                     // MaterialService.toast('Произошла ошибка сервера')
                     
                        const potentialToken = this.tokenService.deleteToken(stream.publicIdentity)
                    
                      this.accessOk = false
                      return of(stream)
                    }) 
                  )
                  //.subscribe((x)=>of(x))
                }
            }
    
          })
         )       
      })

    )).subscribe((stream:any)=>{
     
      this.initialLoading = false
	 this.sessionKey = stream.session?.local_session_id

      this.stream = stream
	 this.description = stream.description.replaceAll(/\n/g, "<br />")

 
    })/**/


	//setTimeout(()=>{

//console.log(this.statService.getLocalSession())

	//},4000)
   


   /* this.route.params.pipe(
      switchMap((params: Params)=>{
        return this.streamsService.getById(params['id'])
      })
    ).subscribe((stream : StreamProject)=>{
      this.stream = stream

      this.initialLoaing = false
     }) */
  }


    		
   getDescription() {
  let text = this.stream.description || "";

  function escapeHtml(s: string) {
    return s.replace(/[&<>"']/g, ch =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]!)
    );
  }

  // экранируем html
  text = escapeHtml(text);

  // заменяем переводы строк на <br/>
  text = text.replace(/\r?\n/g, "<br/>");

  // регулярка для поиска ссылок
  const urlRegex = /\b((?:https?:\/\/|www\.)[^\s<>"]+)/gi;

  // замена ссылок
  return text.replace(urlRegex, (rawUrl) => {
    let cleanUrl = rawUrl.replace(/["'<>]+$/, "");
    if (cleanUrl.startsWith("www.")) {
      cleanUrl = "http://" + cleanUrl;
    }
    return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>`;
  });
}




 goBack(){

   //this.router.back()
	console.log()
	if(window.history.length){
	window.history.back()
	} else {

 
		let params : any = { }
		if(this.isEmbedChannel) {   params.queryParams = { 'embed-channel' : 'true' } }
	  this.router.navigate(['/channels', this.stream.channel.url ], params)
	}
	//if(window.history.back())
 }



  onAuth(data){ 
  
     if(data.success){
      this.accessOk = true
    }
  }


  closeByToken(){
     this.accessOk = false
  }
 
 
  onWatchersExceededLimit(){
   this.watchersExceededLimit = true
  }

 
   ngOnDestroy() { 
 
       
    
   }


}
